import { render } from "./ResumedCharts.vue?vue&type=template&id=1c4894f4"
import script from "./ResumedCharts.vue?vue&type=script&lang=js"
export * from "./ResumedCharts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\OSOLE\\metalpro\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__